import { WMCodesLookupLayout, } from '../../../../../common/lookups/Layouts/WMLayouts';

const AdditionalLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "NETWEIGHTQUANTITY",
                "tableName": "WMTRANSACTIONDETAIL",
                "label": "Net Weight",
                "type": "number", "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "readOnly": true,
            },
            {
                "name": "GROSSWEIGHTQUANTITY",
                "tableName": "WMTRANSACTIONDETAIL",
                "label": "Gross Weight",
                "type": "number", "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "readOnly": true,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "REFERENCE",
                "tableName": "WMTRANSACTIONDETAIL",
                "label": "Reference",
                "type": "text",
                "required": false,
                "visible": true
            }
            ,
            {
                "name": "DETAILSTATUS",
                "tableName": "WMTRANSACTIONDETAIL",
                "label": "Status",
                "type": "text",
                "required": false,
                "visible": true,
                "readOnly": true,
            }
            ,
            {
                "name": "OVERRIDESHIPDAYS",
                "tableName": "WMTRANSACTIONDETAIL",
                "label": "Over Ride Ship Days",
                "type": "select",
                "required": false,
                "visible": true
            }
        ]
    }
];
const CommentLayout = [
    {
        "groupId": 1,
        "label": "Comments",
        "fields": [
            {
                "name": "COMMENT",
                "tableName": "WMTRANSACTIONDETAIL",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "User Defined Comments",
        "fields": [
            {
                "name": "USERDEFINEDCOMMENT",
                "tableName": "WMTRANSACTIONDETAIL",
                "label": "User Defined Comment",
                "type": "textarea",
                "required": false,
                "visible": true
            }
        ]
    }
];
const UserDefinedLayout = [

    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDCODE1",
                "localizedField": "USERDEFINEDCODE_1",
                "tableName": "WMTRANSACTIONDETAIL",
                "label": "CODE 1",
                "type": "lookup",
                "layout":WMCodesLookupLayout({codeType: '13' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE2",
                "localizedField": "USERDEFINEDCODE_2",
                "tableName": "WMTRANSACTIONDETAIL",
                "label": "CODE 2",
                "type": "lookup",
                "layout":WMCodesLookupLayout({codeType: '14' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE3",
                "localizedField": "USERDEFINEDCODE_3",
                "tableName": "WMTRANSACTIONDETAIL",
                "label": "CODE 3",
                "type": "lookup",
                "layout":WMCodesLookupLayout({codeType: '15' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE4",
                "localizedField": "USERDEFINEDCODE_4",
                "tableName": "WMTRANSACTIONDETAIL",
                "label": "CODE 4",
                "type": "lookup",
                "layout":WMCodesLookupLayout({codeType: '16' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE5",
                "localizedField": "USERDEFINEDCODE_5",
                "tableName": "WMTRANSACTIONDETAIL",
                "label": "CODE 5",
                "type": "lookup",
                "layout":WMCodesLookupLayout({codeType: '17' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDDATE1",
                "localizedField": "USERDEFINEDDATE_1",
                "tableName": "WMTRANSACTIONDETAIL",
                "label": "Date 1",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE2",
                "localizedField": "USERDEFINEDDATE_2",
                "tableName": "WMTRANSACTIONDETAIL",
                "label": "Date 2",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE3",
                "localizedField": "USERDEFINEDDATE_3",
                "tableName": "WMTRANSACTIONDETAIL",
                "label": "Date 3",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE4",
                "localizedField": "USERDEFINEDDATE_4",
                "tableName": "WMTRANSACTIONDETAIL",
                "label": "Date 4",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE5",
                "localizedField": "USERDEFINEDDATE_5",
                "tableName": "WMTRANSACTIONDETAIL",
                "label": "Date 5",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDQUANTITY1",
                "localizedField": "USERDEFINEDQUANTITY_1",
                "tableName": "WMTRANSACTIONDETAIL",
                "label": "Quantity 1",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY2",
                "localizedField": "USERDEFINEDQUANTITY_2",
                "tableName": "WMTRANSACTIONDETAIL",
                "label": "Quantity 2",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY3",
                "localizedField": "USERDEFINEDQUANTITY_3",
                "tableName": "WMTRANSACTIONDETAIL",
                "label": "Quantity 3",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY4",
                "localizedField": "USERDEFINEDQUANTITY_4",
                "tableName": "WMTRANSACTIONDETAIL",
                "label": "Quantity 4",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY5",
                "localizedField": "USERDEFINEDQUANTITY_5",
                "tableName": "WMTRANSACTIONDETAIL",
                "label": "Quantity 5",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    },
    {
        "groupId": 4,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDREFERENCE1",
                "localizedField": "USERDEFINEDREFERENCE_1",
                "tableName": "WMTRANSACTIONDETAIL",
                "label": "Reference 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE2",
                "localizedField": "USERDEFINEDREFERENCE_2",
                "tableName": "WMTRANSACTIONDETAIL",
                "label": "Reference 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE3",
                "localizedField": "USERDEFINEDREFERENCE_3",
                "tableName": "WMTRANSACTIONDETAIL",
                "label": "Reference 3",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE4",
                "localizedField": "USERDEFINEDREFERENCE_4",
                "tableName": "WMTRANSACTIONDETAIL",
                "label": "Reference 4",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE5",
                "localizedField": "USERDEFINEDREFERENCE_5",
                "tableName": "WMTRANSACTIONDETAIL",
                "label": "Reference 5",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
]

export {
    AdditionalLayout,
    CommentLayout,
    UserDefinedLayout
} 
